import LineGlobeAltIcon from 'LuxKit/Icons/line/LineGlobeAltIcon'
import PromotionLabel from 'LuxKit/Label/PromotionLabel'
import { slugify } from 'lib/string/stringUtils'
import { useIntl } from 'react-intl'

export const WORLD_TRAVEL_DAY_2026_CAMPAIGN_TAG_SLUG = 'world_travel_day_2026'

export function hasWorldTravelDayCampaignTag(tags: Array<string>): boolean {
  return tags.some(tag => slugify(tag) === WORLD_TRAVEL_DAY_2026_CAMPAIGN_TAG_SLUG)
}

function WorldTravelDayCampaignLabel() {
  const intl = useIntl()

  return (
    <PromotionLabel variant="branded" icon={<LineGlobeAltIcon />}>
      {intl.formatMessage({
        id: 'igKy66PgaLgbjkBO5svK',
        defaultMessage: 'World Travel Day Exclusive',
        description: 'Campaign label shown on offers tagged for the World Travel Day 2026 marketing campaign',
      })}
    </PromotionLabel>
  )
}

export default WorldTravelDayCampaignLabel
